/*
 * @Author: your name
 * @Date: 2021-04-21 10:40:27
 * @LastEditTime: 2021-12-17 16:51:23
 * @LastEditors: name
 * @Description: In User Settings Edit
 * @FilePath: \dtpWeb\src\assets\font\woff\cxt.js
 */
var ctx = {
  iconFont (canvas, style) {
    if (!canvas) {
      return
    }
    var context = canvas.getContext("2d");
    if (!style.multiple) {
      context.clearRect(0, 0, canvas.width, canvas.height);
    }
    style.color ? context.fillStyle = style.color : context.fillStyle = "rgba(0, 0, 0,1)";
    if (style.fontSize) {
      context.font = `${style.fontSize}px ` + 'iconfont';
    }
    
    // var icon = eval('("' + `${style.unicode}`.replace('&#x', '\\u').replace(';', '') + '")');
    if (style.x && style.y) {
      var offset = style.fontSize / 2;
      var x = style.x - offset + Math.floor(typeof style.offsetX === "number" ? style.offsetX : 0)
      var y = style.y + offset + Math.floor(typeof style.offsetX === "number" ? style.offsetY : 0)
      if (style.angle) {
        var angle = style.angle * Math.PI / 180
        context.save();
        var textW = context.measureText(style.unicode).width;
        context.translate(x + textW / 2, y - style.fontSize / 2);
        context.rotate(angle);
        //判断是否带荧光效果
        if(style.isflu)
        {
          context.shadowColor = style.fluorescence
          context.shadowBlur = 5
          context.fillText(style.unicode, -textW / 2, style.fontSize / 2);
          context.shadowColor = style.fluorescence
          context.shadowBlur = 10
          context.fillText(style.unicode, -textW / 2, style.fontSize / 2);
          context.shadowColor = style.fluorescence
          context.shadowBlur = 20
        }
        context.fillText(style.unicode, -textW / 2, style.fontSize / 2);      
        context.restore();
      } else {
        var textW = context.measureText(style.unicode).width;
        context.save();
        context.translate(x + textW / 2, y - style.fontSize / 2);
        if(style.isflu)
        {
          context.shadowColor = style.fluorescence
          context.shadowBlur = 5
          context.fillText(style.unicode, -textW / 2, style.fontSize / 2 - 2);
          context.shadowColor = style.fluorescence
          context.shadowBlur = 10
          context.fillText(style.unicode, -textW / 2, style.fontSize / 2 - 2);
          context.shadowColor = style.fluorescence
          context.shadowBlur = 20
        }
        context.fillText(style.unicode, -textW / 2, style.fontSize / 2 - 2);       
        context.restore();
      }
    } else {
      var icon = eval('("' + `${style.unicode}`.replace('&#x', '\\u').replace(';', '') + '")');
      // context.fillText(icon, 38 / 2 - style.fontSize / 2, 38 / 2 - style.fontSize / 2 + style.fontSize);
      if (style.angle) {
        var angle = style.angle * Math.PI / 180
        context.save();
        var textW = context.measureText(icon).width;
        context.translate(textW / 2, style.fontSize / 2);
        context.rotate(angle);
       //判断是否带荧光效果
        if(style.isflu)
        {
          context.shadowColor = style.fluorescence
          context.shadowBlur = 5
          context.fillText(icon, -textW / 2, style.fontSize / 2 - 5);
          context.shadowColor = style.fluorescence
          context.shadowBlur = 10
          context.fillText(icon, -textW / 2, style.fontSize / 2 - 5);
          context.shadowColor = style.fluorescence
          context.shadowBlur = 20
        }
        context.fillText(icon, -textW / 2, style.fontSize / 2 - 5);

        context.restore();
      } else {
        var textW = context.measureText(icon).width;
        var canvasW = canvas.width
        context.save();
        context.translate(canvasW / 2, canvasW / 2);
       //判断是否带荧光效果
        if(style.isflu)
        {
          context.shadowColor = style.fluorescence
          context.shadowBlur = 5
          context.fillText(icon, -textW / 2, style.fontSize / 2 - 3);
          context.shadowColor = style.fluorescence
          context.shadowBlur = 10
          context.fillText(icon, -textW / 2, style.fontSize / 2 - 3);
          context.shadowColor = style.fluorescence
          context.shadowBlur = 20
        }
        context.fillText(icon, -textW / 2, style.fontSize / 2 - 3);
   
        context.restore();
      }
      // context.fillText(icon, 0, style.fontSize - 3);
    }

    return context;
  },
  //统一处理点的样式
  iconFontStyle (style, x, y) {
    var params = {
      unicode: style.set.unicode,
      fontSize: style.set.size,
      color: style.set.color,
      offsetX: style.set.offsetX,
      offsetY: style.set.offsetY,
      angle: style.set.angle,
      x: x,
      y: y,
      multiple: true,
      fluorescence: style.style.fluorescence ,
      isflu: style.style.isflu   
    }
    return params;
  },
}
export default {
  ctx
}
